import React, { Component } from 'react';
import Utils from "../../Utils";
import './Home.css';
import { Cargando } from '../estados/Cargando';
import { TermsCondiciones } from '../estados/TermsCondiciones';
import { DetalleScore } from '../proveedor/DetalleScore';
import { Container, Button } from 'reactstrap';

export class Home extends Component {
    static displayName = Home.name;

    constructor(props) {
        super(props);

        this.state = {
            profiledata: [],
            proveedor: {},
            estado: 1
        };
        this.getProfileData(this);
    }

    async getProfileData() {
        await Utils.getProfileData()
            .then(data => {
                if (data == null) window.location.href = "/.auth/login";
                else {
                    this.setState({ profiledata: data });
                    this.getGetTermYCond();
                }
            });
        
    }

    async getGetTermYCond() {
        await Utils.getTermYCond()
            .then(data => {
                if (data === 200) this.getProveedor();
                else this.setState({ estado: 2 })
            });
    }

    async setTermYCond() {
        await Utils.aceptarTermYCond()
            .then(this.getProveedor());
    }


    async getProveedor() {
        this.setState({ estado: 1 })
        await Utils.getProveedor()
            .then(data => {
                if (data !== undefined) 
                    this.setState({ proveedor: data, estado: 3 })
                if (data.Id !== undefined)
                    document.getElementById("ultimaActualizacion").textContent = "Ultima publicaci\u00f3n: " + data.UltimaActualizacion;
            }
        )
    }

    render() {
        switch (this.state.estado) {
            case 1: return (<Cargando></Cargando>);
            case 2: return (
                    <Container><Container className="terminos">
                        <TermsCondiciones></TermsCondiciones>
                    <Button color="primary" onClick={() => this.setTermYCond()}>
                            Aceptar
                        </Button>
                    </Container></Container>
                );
            case 3:
                if (this.state.proveedor === -1)
                    return (
                        <div className="container">
                            <div className="row">
                                <div className="col-12 text-center">
                                    <img src="/actualizacion-info.cf.svg" alt="Actualizando la informaci�n" width="450px" />
                                    <div class="cont-text">
                                        <h4>Actualmente no tenemos datos para mostrar</h4>
                                        <p>Estamos trabajando para incorporar m&aacute;s proveedores al sistema</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                if (this.state.proveedor === 0)
                    return (
                        <div className="container">
                            <div className="row">
                                <div className="col-12 text-center">
                                    <img src="/actualizacion-info.cf.svg" alt="Actualizando la informaci�n" width="450px" />
                                    <div class="cont-text">
                                        <h4>Estamos actualizando esta informaci&oacute;n.</h4>
                                        <p>Intente nuevamente mas tarde.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                else return (
                    <DetalleScore proveedor={this.state.proveedor}></DetalleScore>
                );
            default: ;
        }
    }

}
